import { Validator } from "fluentvalidation-ts";

type AssetPosition = {
  floorNumber: number;
  roomNumber: number;
  latitude: string;
  longitude: string;
  liftShaftIdentificationCode: string;
  outSideIdentificationCode: string;
  terraceIdentificationCode: string;
};

type Asset = {
  name: string;
  protocol: string;
  serialNumber: string;
  type: string;
  position: AssetPosition;
  description: string;
};

class AssetPositionValidator extends Validator<AssetPosition> {
  constructor(type: number) {
    super();

    this.ruleFor("floorNumber")
      .notNull()
      .must((val) => val.toString() !== '')
      .withMessage("Campo obbligatorio")
      .when(() => type === 1);

    

    this.ruleFor("outSideIdentificationCode")
      .notEmpty()
      .withMessage("Campo obbligatorio")
      .when(() => type === 2)
      .notNull()
      .withMessage("Campo obbligatorio");

    this.ruleFor("liftShaftIdentificationCode")
      .notEmpty()
      .withMessage("Campo obbligatorio")
      .when(() => type === 3)
      .notNull()
      .withMessage("Campo obbligatorio");

    this.ruleFor("terraceIdentificationCode")
      .notEmpty()
      .withMessage("Campo obbligatorio")
      .when(() => type === 4)
      .notNull()
      .withMessage("Campo obbligatorio");

    this.ruleFor("latitude").notNull().withMessage("Campo obbligatorio");

    this.ruleFor("longitude").notNull().withMessage("Campo obbligatorio");
  }
}

class AssetValidator extends Validator<Asset> {
  constructor() {
    super();

    this.ruleFor("name").notEmpty().notNull().withMessage("Campo obbligatorio");

   

    this.ruleFor("protocol")
      .notEmpty()
      .notNull()
      .withMessage("Campo obbligatorio");

    this.ruleFor("serialNumber")
      .notEmpty()
      .notNull()
      .withMessage("Campo obbligatorio");


      

    this.ruleFor("type").notEmpty().notNull().withMessage("Campo obbligatorio");

    //this.ruleFor("url").notEmpty().notNull().withMessage("Campo obbligatorio");

    this.ruleFor("position").setValidator(
      (asset) => new AssetPositionValidator(Number.parseInt(asset.type))
    );
  }
}

export default AssetValidator;
